<template>
    <div class="text-medium group flex items-center gap-2 text-[15px] border-b border-color-gray-450 lg:border-0 pb-4 lg:pb-6">
        <UserAvatarRound :user="classroom.instructor" size="36" />
        {{ classroom.instructor.full_name }}
        <span class="rounded bg-blue-100 px-2 py-1 text-[13px] text-blue-500"
            >Instructor</span
        >
        <new-modal
            title="Select an instructor"
            size="xl"
            ref="changeInstructorModal"
            v-if="!classroom.archived_at"
        >
            <template #trigger>
                <div class="link hidden group-hover:inline">
                    Change instructor
                </div>
            </template>
            <template #content>
                <div class="text-[15px] text-gray-750">
                    Pick an instructor to be in charge of this classroom
                </div>
                <form @submit.prevent="submitForm">
                    <div class="my-4 flex max-h-96 flex-col overflow-y-scroll">
                        <div
                            class="mb-2 flex items-center gap-2 rounded border border-blue-500 bg-blue-100 p-2 hover:cursor-pointer"
                            @click="
                                form.selectedInstructor =
                                    classroom.instructor.id
                            "
                        >
                            <img
                                v-if="classroom.instructor.avatar"
                                :src="classroom.instructor.avatar"
                                class="h-9 w-9 rounded-full object-contain"
                            />
                            <div
                                class="h-9 w-9 rounded-full bg-gray-300 p-2 text-center text-[15px] font-medium text-gray-800"
                                v-else
                            >
                                {{ classroom.instructor.initials }}
                            </div>
                            {{ classroom.instructor.full_name }}
                        </div>
                        <template v-for="instructor in instructors">
                            <div
                                :class="
                                    'flex items-center gap-2 rounded border p-2 hover:cursor-pointer' +
                                    ' ' +
                                    (form.selectedInstructor !== instructor.id
                                        ? 'border-transparent hover:bg-gray-250'
                                        : 'border-blue-400 bg-blue-50')
                                "
                                v-if="instructor.id !== classroom.instructor.id"
                                @click="form.selectedInstructor = instructor.id"
                            >
                                <img
                                    v-if="instructor.avatar"
                                    :src="instructor.avatar"
                                    class="h-9 w-9 rounded-full object-contain"
                                />
                                <UserInitialsRound v-else :user="instructor" />
                                {{ instructor.full_name }}
                            </div>
                        </template>
                    </div>
                    <div class="">
                        <hr />
                        <div class="mt-4 flex items-center justify-end">
                            <div class="btn btn-transparent" @click="cancel()">
                                Cancel
                            </div>
                            <button
                                :class="
                                    'btn' +
                                    ' ' +
                                    (form.isDirty
                                        ? 'btn-primary'
                                        : 'btn-disabled')
                                "
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </form>
            </template>
        </new-modal>
    </div>
</template>
<script>
import NewModal from "@/Components/NewModal";
import UserInitialsRound from "@/Components/UserInitialsRound";
import UserAvatarRound from "@/Components/UserAvatarRound";

export default {
    name: "GroupClassroomInstructor",
    components: { UserAvatarRound, UserInitialsRound, NewModal },
    props: {
        classroom: {},
    },
    data() {
        return {
            instructors: [],
            form: this.$inertia.form({
                selectedInstructor: this.classroom.instructor.id,
            }),
            loading: true,
        };
    },
    methods: {
        getInstructors() {
            let vm = this;
            axios.get(route("group.get-instructors")).then(function (response) {
                vm.loading = false;
                vm.instructors = response.data;
            });
        },
        submitForm() {
            let vm = this;

            this.$inertia.post(
                route("group.classroom.update-instructor", {
                    classroom: this.classroom.id,
                }),
                {
                    instructorId: this.form.selectedInstructor,
                },
                {
                    onSuccess() {
                        vm.successMessage = "The instructor has been updated";

                        setTimeout(function () {
                            vm.successMessage = null;
                        }, 2000);

                        vm.cancel();
                    },
                }
            );
        },
        cancel() {
            this.form.reset;
            this.$refs.changeInstructorModal.closeModal();
        },
    },
    created() {
        if (!this.classroom.archived_at) {
            this.getInstructors();
        }
    },
};
</script>
